import { Directive, Inject, Injector, Input, OnInit } from "@angular/core";
import { NumberFormat, UserSettings, UserSettingsToken } from "@farris/devkit";
import { BigNumber } from 'bignumber.js';
import moment from 'moment';
import { TextComponent } from '@farris/ui-text';

@Directive({
  selector: '[farris-text-localization]'
})
export class FarrisTextLocalizationDirective implements OnInit {
  @Input('localization') localization: boolean;
  constructor(private injector: Injector, @Inject(UserSettingsToken) private userSettings: UserSettings, private componentRef: TextComponent) {
    this.transform();
  }
  public ngOnInit() {
  }
  private transform() {
    if (this.componentRef) {
      this.componentRef.beforeWriteValue = (value: any, options: any) => {
        let { localizationType = null, showTime = false } = options;
        if (!value) {
          return '';
        }
        if (localizationType && value) {
          localizationType = localizationType.toLowerCase();
          value = this.transformValue(value, localizationType);
          return value;
        } else {
          return undefined;
        }
      };
    }
  }
  private transformValue(value: any, dataType: string) {
    if (dataType === 'date') {
      return this.transformDate(value);
    } else if (dataType === 'datetime') {
      return this.transformDateTime(value);
    }
    // æ¶åéé¢è®¡ç®åæ¾ç¤ºé®é¢ï¼ä¸äºå¤ç
    //  else if (dataType === 'number') {
    //   return this.transformNumber(value);
    // } 
    else {
      return value;
    }
  }
  /**
   * è½¬æ¢æ¥æ
   * @param value value
   */
  private transformDate(value: any) {
    let dateFormat = this.userSettings && this.userSettings.dateFormat || 'YYYY-MM-DD';
    if (!dateFormat || !value) {
      return value;
    }
    const date = moment(value);
    const isValid = date.isValid();
    if (!isValid) {
      return value;
    }
    dateFormat = this.parseDateFormat(dateFormat);
    return date.format(dateFormat);
  }
  /**
   * è½¬æ¢æ¥ææ¶é´
   * @param value value
   * todo: ç®åæ æ³å®ä¹æ¥ææ¶é´æ ¼å¼
   */
  private transformDateTime(value: any) {
    let dateFormat = this.userSettings && this.userSettings.dateFormat || 'YYYY-MM-DD';
    let timeFormat = this.userSettings && this.userSettings.timeFormat || 'HH:mm:ss';
    if (!dateFormat || !timeFormat) {
      return value;
    }
    const dateTime = moment(value);
    const isValid = dateTime.isValid();
    if (!isValid) {
      return value;
    }
    if (dateFormat) {
      dateFormat = this.parseDateFormat(dateFormat);
    }
    if (timeFormat) {
      timeFormat = this.parseTimeFormat(timeFormat);
    }
    const dateTimeFormat = dateFormat + ' ' + timeFormat;
    return dateTime.format(dateTimeFormat);
  }
  /**
   * è½¬æ¢æ°å­
   * @param value value
   */
  private transformNumber(value): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const bigNumber = new BigNumber(value);
    // å¦æä¸æ¯æ°å­ï¼ä¸åä»»ä½å¤ç
    if (!BigNumber.isBigNumber(bigNumber)) {
      return value;
    }
    const isNegative = bigNumber.isNegative();
    const format = this.buildNumberFormat();
    const { negativeSign = null, numberDecimalDigits = null } = this.numberFormat || {};
    if (isNegative) {
      if (negativeSign !== null) {
        format.prefix = negativeSign;
        return bigNumber.absoluteValue().toFormat(numberDecimalDigits, null, format);
      }
    }
    return bigNumber.toFormat(numberDecimalDigits, null, format);
  }
  /**
   * è½¬æ¢æ¥ææ ¼å¼è§åä¸ºmomentçformatè§å
   * @param format format
   */
  private parseDateFormat(format: string) {
    return format.replace(/y/g, 'Y').replace(/d/g, 'D');
  }
  /**
   * è½¬æ¢æ¶é´æ ¼å¼è§åä¸ºmomentçformatè§å
   * @param format format
   */
  private parseTimeFormat(format: string) {
    return format.replace(/M/g, 'm');
  }
  /**
   * æé bignumberæ°å­æ ¼å¼åéé¡¹
   */
  private buildNumberFormat() {
    if (this.numberFormat) {
      const { numberDecimalSeparator = null, numberGroupSeparator = null } = this.numberFormat;
      const format: any = {
        groupSize: 3,
      };
      if (numberDecimalSeparator !== null) {
        format.decimalSeparator = numberDecimalSeparator;
      }
      if (numberGroupSeparator !== null) {
        format.groupSeparator = numberGroupSeparator;
      }
      return format;
    }
  }
  private get numberFormat(): NumberFormat {
    return this.userSettings && this.userSettings.numberFormat || null;
  }
}